import { getStoredCountryCode } from "@/lib/data/country-code"
import { normalizeCheckoutStep } from "@/lib/utils/checkout-steps"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/checkout")({
  validateSearch: (search) => ({
    step: normalizeCheckoutStep(search.step),
  }),
  loaderDeps: ({ search: { step } }) => ({
    step,
  }),
  loader: async ({ deps }) => {
    const { countryCode } = await getStoredCountryCode()

    throw redirect({
      to: "/$countryCode/checkout",
      search: { step: deps.step },
      params: { countryCode },
    })
  },
})
